import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {FC} from 'react'
import {ReportOccupancy} from '../ReportOccupancy'
import {ReportOccupancy2} from '../ReportOccupancy2'
const HeaderReportOccupancyPanel: FC = () => {
  return (
    <>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Historial de Pernoctes</Tab>
            <Tab className={'sdx_sub_tab_panel_option'}>Detalle de Ocupabilidad Diaria</Tab>
          </TabList>
          <TabPanel>
            <ReportOccupancy />
          </TabPanel>
          <TabPanel>
            <ReportOccupancy2 />
          </TabPanel>
        </Tabs>
      </div>
    </>
  )
}

export {HeaderReportOccupancyPanel}
